module.exports = __webpack_public_path__ + "static/media/circle-medium.bca2a47e.svg";